import Vue  from 'vue';
import Vuex from 'vuex';
import User from './user.js';

Vue.use( Vuex );

const store = new Vuex.Store(
                {
                    state: {
                        user: {
                            isAuthenticated: User.isAuthenticated(), //false,
                            username:        User.getUsername(),     //'',
                            longUsername:    User.getLongUsername()  //''
                        }
                    },
                    actions: {
                    },
                    mutations: {
                    },
                    getters: {
                    },
                    modules: {
                    }
                }
            );

export default store;



// WEBPACK FOOTER //
// ./src/store.js